import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

interface OwnProps {
	id: number;
	onDelete: (id: number) => void;
}

type Props = OwnProps;

const GroupActions: React.FC<Props> = (props) => {
	const { id, onDelete } = props;

	const handleDelete = React.useCallback(() => {
		onDelete(id);
	}, [id, onDelete]);

	return (
		<div>
			<Button
				icon="Delete"
				onClick={handleDelete}
				style="link-danger"
				type="button"
			/>
		</div>
	);
};

export default GroupActions;
